function checkRadio(radioName, container) {
	// 获取所有 name 为 "gender" 的 radio input
	const ct = container || document
	const radios = ct.querySelectorAll(`input[name=${radioName}]`);
	let isChecked = false;

	// 遍历 radio input，检查是否有被选中的
	radios.forEach(radio => {
		// @ts-ignore
		if (radio.checked) {
			isChecked = true;
		}
	});

	return isChecked
}

export default checkRadio
